
import { TABLEAU_FUNDAMENTALS_COURSE } from './fundamentals';
import { TABLEAU_INTERMEDIATE_COURSE } from './intermediate';
import { TABLEAU_EXPERT_COURSE } from './expert';
import { TableauCourse } from './types';

export const TABLEAU_COURSES: TableauCourse[] = [
  TABLEAU_FUNDAMENTALS_COURSE,
  TABLEAU_INTERMEDIATE_COURSE,
  TABLEAU_EXPERT_COURSE
];

export * from './types';
export * from './fundamentals';
export * from './intermediate';
export * from './expert';
